import styled from 'styled-components';

const LineSeparator = styled.div`
    width: 100%;
    border-top: 1px solid ${({ theme }) => theme.colors.charcoal20};
`;

export default LineSeparator;
